import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

/**
 * ============================================================================
 * SEC_03_00_PostLoginHandoff
 * ----------------------------------------------------------------------------
 * Purpose:
 *   Acts as a stabilization layer between successful authentication
 *   and entry into secured application routes.
 *
 * Responsibilities:
 *   - Waits for AuthProvider to finish initializing
 *   - Ensures a user session exists
 *   - Ensures the security matrix has been hydrated
 *   - Redirects ONLY when the system is stable
 *
 * Important:
 *   - NO guards
 *   - NO role checks
 *   - NO permission logic
 *   - NO redirects during initialization
 * ============================================================================
 */

export default function SEC_03_00_PostLoginHandoff() {
  const navigate = useNavigate();
  const { user, matrix, isInitialising } = useAuth();

  useEffect(() => {
    // 1. Wait for AuthProvider to finish bootstrapping
    if (isInitialising) return;

    // 2. If no authenticated user exists, return to sign-in
    if (!user) {
      navigate("/auth/sign-in", { replace: true });
      return;
    }

    // 3. Matrix has resolved (even if empty)
    //    At this point guards are safe to execute
    if (Array.isArray(matrix)) {
      navigate("/registered/dashboard", { replace: true });
    }
  }, [isInitialising, user, matrix, navigate]);

  return (
    <main className="page-main">
      <div className="page-main-inner d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" />
          <p className="text-muted">
            Finalizing secure session…
          </p>
        </div>
      </div>
    </main>
  );
}
